export enum TemplateLayoutKeys {
  DefaultLayout = 'default',
  HeroLayout = 'hero',
}
